export const TYPOGRAPHY_COMPONENTS = {
    a: [
        'text-interactive-primary-default',
        'dark:text-interactive-primary-default-dark',
        'underline',
        'transition',
        'ease-in-out',
        'duration-200',
        'hover:!text-interactive-primary-hover',
        'dark:hover:!text-interactive-primary-hover-dark',
    ],
    button: [
        'text-interactive-primary-default',
        'dark:text-interactive-primary-default-dark',
        'underline',
        'border-none',
        'bg-none',
        'p-0',
        'transition',
        'ease-in-out',
        'duration-200',
        'disabled:cursor-not-allowed',
        'disabled:text-content-disabled',
        'dark:disabled:text-content-disabled-dark',
        'enabled:cursor-pointer',
        'hover:enabled:!text-interactive-primary-hover',
        'dark:hover:enabled:!text-interactive-primary-hover-dark',
    ],
};
